import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosResponse } from "axios";
import { ErrorResponse } from "@/common/types/errorResponse";

interface UseReviewContactProps {
  contactId?: string
  publicCompanyLeadId?: string
  state?: string
  onSuccess: (response: AxiosResponse) => void
  onError: (error: ErrorResponse) => void
}

export const useReviewContact = ({ contactId, publicCompanyLeadId, state, onSuccess, onError }: UseReviewContactProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['reviewContact'],
    mutationFn: (data?: { description?: string }) => {
      const lead = {
        contacts_attributes: [
          {
            id: contactId,
            last_review_attributes: {
              state,
              description: data?.description
            }
          }
        ]
      }

      return privateAxios.put(`/funnel/public/leads/${publicCompanyLeadId}`, {
        lead
      })
    },
    onSuccess,
    onError,
  });
}
